import React, { useEffect } from 'react';
import './AgriTraining.css';
import {
  Sprout, Droplets, TreePine, Tractor, Leaf, HeartHandshake,
  Factory, ChartBar, Globe, ClipboardCheck, Users,
  GraduationCap, University, UserCheck, Building2
} from 'lucide-react';

const AgriTraining = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const trainingCategories = [
    {
      title: "School Training",
      image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729347363/international-day-education-dark-style-with-students-classroom_vsqiq1.jpg",
      icon: <GraduationCap size={24} />,
      desc: "Instilling sustainability values in young minds through practical workshops."
    },
    {
      title: "College Training",
      image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729347599/international-day-education-dark-style_vasxzx.jpg",
      icon: <University size={24} />,
      desc: "Technical courses on modern agricultural technologies and research."
    },
    {
      title: "Farmers Training",
      image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729350493/Farmers_Training_in_Indian_surroundings_with_greenery_in_the_style_of_Impressionist_paintings_dtio7w.jpg",
      icon: <UserCheck size={24} />,
      desc: "Hands-on guidance for yield maximization and advanced crop management."
    },
    {
      title: "NGOs Training",
      image: "https://res.cloudinary.com/drevfgyks/image/upload/v1729356561/people-taking-part-high-protocol-event_wlvhn5.jpg",
      icon: <Building2 size={24} />,
      desc: "Collaborative programs for rural development and community empowerment."
    }
  ];

  const trainingModules = [
    { icon: <Sprout />, title: 'Introduction to Agriculture' },
    { icon: <Droplets />, title: 'Soil Science & Management' },
    { icon: <TreePine />, title: 'Crop Production' },
    { icon: <Droplets />, title: 'Irrigation Systems' },
    { icon: <Leaf />, title: 'Pest Management' },
    { icon: <HeartHandshake />, title: 'Organic Farming' },
    { icon: <Tractor />, title: 'Farm Mechanization' },
    { icon: <TreePine />, title: 'Agroforestry' },
    { icon: <Factory />, title: 'Post-Harvest Mgmt' },
    { icon: <ChartBar />, title: 'Agribusiness' },
    { icon: <Globe />, title: 'Field Visits' },
    { icon: <Leaf />, title: 'Food Security' },
    { icon: <Users />, title: 'Eco-Conservation' },
    { icon: <ClipboardCheck />, title: 'Quality Certification' },
    { icon: <HeartHandshake />, title: 'Policy & Advocacy' },
  ];

  return (
    <div className="at-premium-page">

      {/* Hero Section */}
      <section className="at-hero">
        <div className="at-hero-overlay"></div>
        <div className="at-hero-content">
          <span className="at-hero-badge">Knowledge & Growth</span>
          <h1 className="at-hero-title">Agricultural Training Programs</h1>
          <p className="at-hero-subtitle">
            Empowering the next generation of farmers and professionals with practical skills,
            technical knowledge, and sustainability awareness.
          </p>
        </div>
      </section>

      <div className="at-container">

        {/* Intro Text */}
        <div className="at-intro-section">
          <p className="at-intro-text">
            ANT provides comprehensive training programs in schools, colleges, and NGOs.
            Our modules are tailored to different age groups and contexts, covering a wide range
            of topics from basic farming to advanced agribusiness strategies.
          </p>
        </div>

        {/* Target Audience Categories */}
        <section className="at-categories-section">
          <h2 className="at-section-heading">Training for Every Level</h2>
          <div className="at-categories-grid">
            {trainingCategories.map((cat, index) => (
              <div key={index} className="at-category-card">
                <div
                  className="at-category-image"
                  style={{ backgroundImage: `url(${cat.image})` }}
                ></div>
                <div className="at-category-content">
                  <div className="at-category-icon">{cat.icon}</div>
                  <h3 className="at-category-title">{cat.title}</h3>
                  <p className="at-category-desc">{cat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Training Modules Grid */}
        <section className="at-modules-section">
          <h2 className="at-section-heading">Comprehensive Curriculum</h2>
          <div className="at-modules-grid">
            {trainingModules.map((module, index) => (
              <div key={index} className="at-module-card">
                <div className="at-module-icon-box">
                  {React.cloneElement(module.icon, { size: 28, strokeWidth: 1.5 })}
                </div>
                <h4 className="at-module-title">{module.title}</h4>
              </div>
            ))}
          </div>
        </section>

        <div className="at-footer-tag">Emerging Farmers Empowerment</div>

      </div>
    </div>
  );
};

export default AgriTraining;
